import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import {
  IGlobalSocialNetworksState,
  selectSocialNetworks,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import AssignmentViewPage from '../components/AssignmentViewPage'
import {
  actionCreators,
  IAssignmentDetailState,
  selectError,
  selectIsDeleting,
  selectIsLoading,
  selectItem,
  selectPermissions,
  selectScope,
  selectShowConfirmDelete,
} from '../modules/assignmentDetail'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IAssignmentDetailState & ICurrentUserState & IGlobalSocialNetworksState
    >({
      error: selectError(),
      isDeleting: selectIsDeleting(),
      isLoading: selectIsLoading(),
      item: selectItem(),
      permissions: selectPermissions(),
      scope: selectScope(),
      showConfirmDelete: selectShowConfirmDelete(),
      socialNetworks: selectSocialNetworks(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(AssignmentViewPage),
)
